import Vue from 'vue'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale'
import lang from 'element-ui/lib/locale/lang/ru-RU'
locale.use(lang)

import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);